/* eslint-disable */
// @ts-nocheck

/**
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as GoogleProtobufStruct from '../../../google/protobuf/struct.pb';
import * as GoogleProtobufTimestamp from '../../../google/protobuf/timestamp.pb';
import * as fm from '@generated/fetch.pb';

type StructPBValue =
    | null
    | boolean
    | string
    | number
    | { [key: string]: StructPBValue }
    | StructPBValue[];

export type GetV3FeedbackOptionsRequest = Record<string, never>;

export type GetV3FeedbackOptionsResponse = {
    comfortLevels?: V3ComfortLevel[];
    participationLevels?: V3ParticipationLevel[];
    /** @deprecated This field has been deprecated. */
    feedbackFlags?: V3FeedbackFlag[];
    positiveStandoutOptions?: V3FeedbackOption[];
    thingsToImproveOptions?: V3FeedbackOption[];
};

export type V3ComfortLevel = {
    id?: number;
    name?: string;
    participationLevelIds?: number[];
};

export type V3ParticipationLevel = {
    id?: number;
    name?: string;
};

export type V3FeedbackFlag = {
    id?: number;
    feedback?: string;
};

export type V3FeedbackOption = {
    key?: string;
    value?: string;
};

export type LearningObjective = {
    code?: string;
    statement?: string;
};

export type V3FeedbackSession = {
    id?: string;
    garageSessionId?: string;
    garageCourseName?: string;
    garageSessionStartTime?: GoogleProtobufTimestamp.Timestamp;
    garageSessionEndTime?: GoogleProtobufTimestamp.Timestamp;
    garageTeacherId?: string;
    garageTeacherName?: string;
    garageLevelId?: string;
    garageLevelLabel?: string;
    alexandriaUnitId?: string;
    isComplete?: boolean;
    levelObjectives?: LearningObjective[];
    unitObjectives?: LearningObjective[];
    alexandriaUnitName?: string;
    sessionType?: string;
    unitSessionNumber?: number;
    deliveryType?: string;
    students?: V3StudentFeedback[];
    studentUnitFeedbacks?: StudentUnitFeedback[];
};

export type V3StudentFeedback = {
    id?: string;
    feedbackId?: string;
    garageStudentId?: string;
    garageStudentName?: string;
    garageStudentNickname?: string;
    btsAttendance?: boolean;
    comfortLevelId?: number;
    participationLevelId?: number;
    positiveStandout?: string;
    observationNote?: string;
    improvementNotes?: string;
    urgentEscalation?: string;
    studentUnitFeedbackId?: string;
    requiresObjectiveAssessment?: boolean;
};

export type StudentUnitFeedback = {
    id?: string;
    filledOnStudentFeedbackDetailsId?: string;
    type?: string;
    status?: string;
    alexandriaUnitOfferingId?: string;
    objectives?: Record<string, string>;
    formativeSkillDevelopments?: { [key: string]: StructPBValue }[];
};

export type GetV3FeedbackDetailsRequest = {
    sessionId?: string;
};

export type GetV3FeedbackDetailsResponse = {
    session?: V3FeedbackSession;
    students?: V3StudentFeedback[];
    studentUnitFeedbacks?: StudentUnitFeedback[];
};

export type AttendanceInfo = {
    attendance?: boolean;
    punctuality?: boolean;
};

export type V3StudentFeedbackInput = {
    studentId?: string;
    attendanceInfo?: AttendanceInfo;
};

export type PostV3FeedbackDetailsRequest = {
    sessionId?: string;
    requester?: string;
    courseId?: string;
    roomId?: string;
    teacherId?: string;
    feedbacks?: V3StudentFeedbackInput[];
};

export type PostV3FeedbackDetailsResponse = {
    success?: boolean;
    message?: string;
    feedbackId?: string;
};

export type V3StudentFeedbackUpdate = {
    garageStudentId?: string;
    btsAttendance?: boolean;
    comfortLevelId?: number;
    participationLevelId?: number;
    positiveStandout?: string;
    observationNote?: string;
    improvementNotes?: string;
    urgentEscalation?: string;
};

export type StudentUnitFeedbackUpdate = {
    id?: string;
    objectives?: Record<string, string>;
};

export type PutV3FeedbackDetailsRequest = {
    sessionId?: string;
    requester?: string;
    isComplete?: boolean;
    students?: V3StudentFeedbackUpdate[];
    unitFeedbacks?: StudentUnitFeedbackUpdate[];
};

export type PutV3FeedbackDetailsResponse = {
    success?: boolean;
    message?: string;
};

export type GetV3FeedbackByFilterRequest = {
    teacherId?: string;
    startDate?: GoogleProtobufTimestamp.Timestamp;
    endDate?: GoogleProtobufTimestamp.Timestamp;
    studentId?: string;
    alexandriaUnitId?: string;
    page?: number;
    pageSize?: number;
    teacherEmail?: string;
    withDetails?: boolean;
    withUnitFeedbacks?: boolean;
};

export type GetV3FeedbackByFilterResponse = {
    sessions?: V3FeedbackSession[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
};

export class TeacherFeedbackV3Service {
    static GetV3FeedbackDetails(
        this: void,
        req: GetV3FeedbackDetailsRequest,
        initReq?: fm.InitReq
    ): Promise<GetV3FeedbackDetailsResponse> {
        return fm.fetchRequest<GetV3FeedbackDetailsResponse>(
            `/v3/feedback/sessions/${
                req.sessionId
            }/details?${fm.renderURLSearchParams(req, ['sessionId'])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static PostV3FeedbackDetails(
        this: void,
        req: PostV3FeedbackDetailsRequest,
        initReq?: fm.InitReq
    ): Promise<PostV3FeedbackDetailsResponse> {
        return fm.fetchRequest<PostV3FeedbackDetailsResponse>(
            `/v3/feedback/sessions/${req.sessionId}/details`,
            { ...initReq, method: 'POST', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static PutV3FeedbackDetails(
        this: void,
        req: PutV3FeedbackDetailsRequest,
        initReq?: fm.InitReq
    ): Promise<PutV3FeedbackDetailsResponse> {
        return fm.fetchRequest<PutV3FeedbackDetailsResponse>(
            `/v3/feedback/sessions/${req.sessionId}/details`,
            { ...initReq, method: 'PUT', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static GetV3FeedbackByFilter(
        this: void,
        req: GetV3FeedbackByFilterRequest,
        initReq?: fm.InitReq
    ): Promise<GetV3FeedbackByFilterResponse> {
        return fm.fetchRequest<GetV3FeedbackByFilterResponse>(
            `/v3/feedback?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetV3FeedbackOptions(
        this: void,
        req: GetV3FeedbackOptionsRequest,
        initReq?: fm.InitReq
    ): Promise<GetV3FeedbackOptionsResponse> {
        return fm.fetchRequest<GetV3FeedbackOptionsResponse>(
            `/v3/feedback/options?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
}
